import { SupplierBookingWebService } from '@linktivity/gds-neo';
import config from '../config';

const supplierBookingApi = new SupplierBookingWebService.BookingApi(config);

export default supplierBookingApi;
